import { Component, Input, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../forms';

@Component({
  selector: 'pty-customer-notes',
  templateUrl: './customer-notes.component.html',
  styleUrls: ['./customer-notes.component.scss']
})
export class CustomerNotesComponent {
  @Input() partyId:string;
  //CustomerNotes
  listForm:OfbizList;
  
  title:"Customer Notes";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}
  
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerNotes",
        listFormLocation:"component://kwikstore/widget/PartyForms.xml",
        columnFields:getFields("CustomerNotes",PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerNotes",PART_FORMS),
        //fieldFormFields:any,
        listType:"list",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerNotes",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"CustomerNotes",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerNotes",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerNotes",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }
}
